import React from "react";
import styles from "../styles/About.module.css";

const About: React.FC = () => {
  return (
    <div className={styles.about}>

      <section className={styles.content}>
        <div className={styles.textSection}>
          <h2>Who We Are</h2>
          <p>
            At <strong>GreystarMotors</strong>, we simplify the process of
            owning your dream car. Based in Kampala, we specialize in sourcing,
            importing, and delivering quality vehicles from Japan, the UK, and
            beyond — all while maintaining transparency and top-notch service.
          </p>
          <p>
            With years of experience in international logistics, customs, and
            inspection procedures, our goal is to ensure that every client gets
            a vehicle that meets both their expectations and budget.
          </p>
        </div>

        <div className={styles.imageSection}>
          <img
            src="/car-service.jpg"
            alt="Luxury car"
          />
        </div>
      </section>

      <section className={styles.mission}
      style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/background2.jpg)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'scroll',
    }}>
        <h2>OUR MISSION</h2>
        <p>
          To make car ownership seamless and accessible by combining
          international reach with local expertise — ensuring every imported
          vehicle delivers reliability, style, and value.
        </p>

        <div className={styles.values}>
          <div className={styles.valueCard}>
            <h3>QUALITY</h3>
            <p>
              Every car is thoroughly inspected and verified before shipment to
              ensure durability and performance.
            </p>
          </div>
          <div className={styles.valueCard}>
            <h3>INEGRITY</h3>
            <p>
              We maintain full transparency — no hidden fees, no false promises,
              just genuine service.
            </p>
          </div>
          <div className={styles.valueCard}>
            <h3>EXCELLENT</h3>
            <p>
              We go beyond importation — offering consultation, inspection
              reports, and delivery assistance.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
